/**
 * Utilities for detecting and cleaning messages that show the "Submit a support request" CTA.
 * Marker must stay aligned with campuskudos-web and backend / LLM prompts.
 */

const SUPPORT_REQUEST_CTA_MARKER = '<!-- SUPPORT_REQUEST_CTA -->';

const LEGACY_TICKET_LINK_REGEX =
  /<a\s+[^>]*target\s*=\s*["']#createTicket["'][^>]*>[\s\S]*?<\/a>/gi;

export const messageContainsSupportRequestCta = message => {
  if (!message || typeof message !== 'string') {
    return false;
  }
  return (
    message.includes(SUPPORT_REQUEST_CTA_MARKER) ||
    /target\s*=\s*["']#createTicket["']/i.test(message)
  );
};

export const getCleanedMessageForSupportRequestCta = message => {
  if (!message || typeof message !== 'string') {
    return message;
  }
  let cleaned = message.split(SUPPORT_REQUEST_CTA_MARKER).join('').trim();
  cleaned = cleaned.replace(LEGACY_TICKET_LINK_REGEX, 'support request');
  return cleaned;
};
